import { MagentoGraphQl } from '../Graphql/MagentoGraphQl';

export default MagentoGraphQl;
